import { computed, Injectable } from "@angular/core";
import { secureRandomInt } from "src/app/shared/utils/secure-random";

@Injectable({
  providedIn: "root",
})
export class RandomImageLoaderService {
  private readonly availableImages: string[] = Array.from(
    { length: 43 },
    (_, i) => `assets/images/employees/employee-${i}.png`
  );

  image = computed(() => this.availableImages[this.getRandomImageIndex()]);

  private getRandomImageIndex(): number {
    return secureRandomInt(this.availableImages.length);
  }
}
